<template>
  <d-form @submit.prevent="submit" :validated="hasErrors">
    <d-form-row>
      <!-- Nome -->
      <d-col md="8" class="form-group">
        <label for="label">Identificação da obra</label>
        <d-form-input
          :state="hasErrorFiled('label')"
          type="text"
          id="label"
          placeholder="Nome"
          v-model="model.label"
          :disabled="isCustomer"
        />
        <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
      </d-col>

      <!-- Data Inicio -->
      <d-col md="2" class="form-group">
        <label for="feInputDataInicio">Previsão de início</label>
        <datepicker :model.sync="model.started_at" :disabled="isCustomer" />
      </d-col>

      <!-- Data Fim -->
      <d-col md="2" class="form-group">
        <label for="feInputDataInicio">Entrega de obra</label>
        <datepicker disabled :model.sync="model.finished_at" />
      </d-col>
    </d-form-row>

    <d-form-row>
      <!-- Nome -->
      <d-col md="8" class="form-group autocomplete" v-if="customerId === null">
        <label for="name">
          Cliente
          <span v-if="!isCustomer" class="link" @click.prevent="addNewClient()"
            >Adicionar novo cliente</span
          >
        </label>
        <span class="form-control" readonly v-if="isCustomer">{{
          model.customer ? model.customer.name : "Nome do cliente"
        }}</span>
        <autocomplete
          ref="autocomplete"
          placeholder="Cliente"
          :state="hasErrorFiled('customer_id')"
          :items="custumers"
          item-show="name"
          :on-input="onInput"
          :on-select="setProjectCustomer"
          :on-show-text="showText"
          v-if="!isCustomer"
        ></autocomplete>
        <d-form-invalid-feedback>Cliente é obrigatório</d-form-invalid-feedback>
      </d-col>

      <!-- Status -->
      <d-col cols="4" class="form-group" v-if="model.id">
        <label for="feStatus">Status</label>
        <d-select
          v-model="model.status_id"
          :options="statusOptions"
          value-field="status_id"
          text-field="name"
          @change="changeStatus"
          :disabled="isCustomer"
        >
        </d-select>
      </d-col>
    </d-form-row>

    <d-form-row>
      <!-- CEP -->
      <d-col md="2" class="form-group">
        <label for="inputCEP">CEP</label>
        <masked-input
          type="text"
          class="text-left form-control"
          id="inputCEP"
          placeholder="00.000-000"
          :mask="[/\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]"
          :guide="false"
          v-model="model.address.zipcode"
          :class="['is-' + hasErrorFiled('zipcode')]"
          @blur="consultaCEP(model.address.zipcode)"
          :disabled="isCustomer"
        ></masked-input>
        <d-form-invalid-feedback>CEP é obrigatório</d-form-invalid-feedback>
      </d-col>

      <!-- Logradouro -->
      <d-col md="8" class="form-group">
        <label for="feInputEndereco">Logradouro</label>
        <d-form-input
          type="text"
          id="feInputEndereco"
          placeholder="Rua,Av,Travessa"
          v-model="model.address.street"
          @change="capitalizeInput('street')"
          :state="hasErrorFiled('street')"
          :disabled="isCustomer"
        />
        <d-form-invalid-feedback
          >Logradouro é obrigatório</d-form-invalid-feedback
        >
      </d-col>

      <!-- Numero -->
      <d-col md="2" class="form-group">
        <label for="feInputNumero">Número</label>
        <d-form-input
          type="text"
          id="feInputNumero"
          placeholder="Número"
          v-model="model.address.number"
          :state="hasErrorFiled('number')"
          :disabled="isCustomer"
        />
        <d-form-invalid-feedback>Número é obrigatório</d-form-invalid-feedback>
      </d-col>
    </d-form-row>

    <d-form-row>
      <!-- Complemento -->
      <d-col md="3" class="form-group">
        <label for="feInputComplemento">Complemento</label>
        <d-form-input
          type="text"
          id="feInputComplemento"
          v-model="model.address.address2"
          placeholder="apartamento,bloco,etc..."
          @change="capitalizeInput('address2')"
          :disabled="isCustomer"
        />
      </d-col>

      <!-- Bairro -->
      <d-col md="3" class="form-group">
        <label for="feInputBairro">Bairro</label>
        <d-form-input
          type="text"
          id="feInputBairro"
          v-model="model.address.district"
          @change="capitalizeInput('district')"
          :state="hasErrorFiled('district')"
          :disabled="isCustomer"
        />
        <d-form-invalid-feedback>Bairro é obrigatório</d-form-invalid-feedback>
      </d-col>

      <!-- Cidade -->
      <d-col md="4" class="form-group">
        <label for="feInputCidade">Cidade</label>
        <d-form-input
          type="text"
          id="feInputCidade"
          v-model="model.address.city"
          @change="capitalizeInput('city')"
          :state="hasErrorFiled('city')"
          :disabled="isCustomer"
        />
        <d-form-invalid-feedback>Cidade é obrigatório</d-form-invalid-feedback>
      </d-col>

      <!-- Estado -->
      <d-col md="2" class="form-group">
        <label for="feInputEstado">Estado</label>
        <select-state
          :model.sync="model.address.state"
          :validate="hasErrorFiled('state')"
          :disabled="isCustomer"
        />
        <d-form-invalid-feedback>Estado é obrigatório</d-form-invalid-feedback>
      </d-col>
    </d-form-row>

    <d-form-row v-if="!isCustomer">
      <!-- Anotações -->
      <d-col md="12" class="form-group">
        <label for="feDescription">Anotações</label>
        <textarea
          id="feDescription"
          v-model="model.comment"
          rows="5"
          class="form-control"
        ></textarea>
      </d-col>
    </d-form-row>
    <add-customer-modal />
  </d-form>
</template>

<script>
import { mapActions } from 'vuex';
import mixin from '_common/mixins/ValidateForm';
import Events from '_utils/events';
import Loader from '_shared/Loader.vue';
import Datepicker from '_shared/Datepicker.vue';
import InputPhone from '_shared/InputPhone.vue';
import MaskedInput from 'vue-text-mask';
import SelectState from '_shared/SelectState.vue';
import Autocomplete from '_shared/Autocomplete.vue';
import ProjectService from '_services/rest/modules/project';
import AddCustomerModal from '_modules/project/components/modal/AddCustomerModal.vue';
import { capitalize, getDateISO, cloneDeep } from '_utils';
import { MODEL, _LOAD_MODEL_, _SAVE_PROJECT_SUCCESS_, _OPEN_CONFIRMATION_ } from './ProjectModel';
import { _SAVE_CUSTOMER_SUCCESS_ } from '../../customer/components/CustomerModel';

export default {
  name: 'project-form',
  mixins: [mixin],
  components: {
    Loader,
    Datepicker,
    InputPhone,
    MaskedInput,
    SelectState,
    Autocomplete,
    AddCustomerModal,
  },
  props: {
    customerId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      model: cloneDeep(MODEL),
      loading: false,
      isCustomer: false,
      errors: {
        label: { required: false },
        customer_id: { required: false },
        city: { required: false },
        state: { required: false },
        district: { required: false },
        street: { required: false },
        number: { required: false },
        zipcode: { required: false },
      },
      changedStatusId: false,
    };
  },
  computed: {
    custumers() {
      const { customerList } = this.$store.state.customer;
      if (customerList && customerList.list.length) {
        return customerList.list;
      }
      return [];
    },
    status() {
      const { attachedStatus } = this.$store.state.project;
      if (attachedStatus) {
        return attachedStatus;
      }
      return [];
    },
    statusOptions() {
      return [{ id: null, status_id: null, name: 'Selecione um status' }].concat(this.status);
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getCustomerList',
      'checkIsCustomer',
      'getProjectStatus',
    ]),
    addNewClient() {
      this.setToggle({ type: 'add_customer_modal', bool: true });
    },
    capitalizeInput(field) {
      this.model[field] = capitalize(this.model[field]);
    },
    changeStatus(value) {
      this.changedStatusId = (this.model.status_id !== value);
      this.model.status_id = value;
    },
    checkUser() {
      this.checkIsCustomer().then(response => {
        this.isCustomer = response;
      });
    },
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    consultaCEP(cep) {
      ProjectService.getCep(cep)
        .then(response => {
          this.model.address.city = response.localidade;
          this.model.address.state = response.uf;
          this.model.address.street = response.logradouro;
          this.model.address.district = response.bairro;
        });
    },
    getListCustomer(name = '') {
      const params = {
        skip: 0,
        take: 10,
        search: name,
      };
      this.getCustomerList(params);
    },
    onInput(name) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.getListCustomer(name);
      }, 500);
    },
    save() {
      ProjectService.save(this.model)
        .then(response => {
          this.activeAlert({ message: 'Obra salvo com sucesso', theme: 'success' });
          Events.$emit(_SAVE_PROJECT_SUCCESS_, response);
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
    submit() {
      if (this.customerId) {
        this.model.customer_id = this.customerId;
      }
      if (this.checkForm()) {
        this.model.started_at = getDateISO(new Date(this.model.started_at));
        setTimeout(() => {
          if (this.model.status_id === null || !this.changedStatusId) {
            return this.save();
          }
          Events.$emit(_OPEN_CONFIRMATION_, { project: this.model, type: 'update' });
          this.setToggle({ type: 'confirm_modal', bool: true });
          return true;
        }, 10);
      }
      return null;
    },
    setClient(customer) {
      if (this.$refs.autocomplete && customer) {
        this.$refs.autocomplete.$refs.input.value = customer.name;
      }
    },
    setProjectCustomer(customer) {
      this.model.customer = customer;
      this.model.customer_id = customer.id;
    },
    showText(item) {
      return `${item.name} <strong class="document">${item.document}</strong>`;
    },
  },
  destroyed() {
    Events.$off(_SAVE_CUSTOMER_SUCCESS_);
    Events.$off(_LOAD_MODEL_);
  },
  mounted() {
    this.checkUser();
    Events.$on(_SAVE_CUSTOMER_SUCCESS_, customer => {
      this.setToggle({ type: 'add_customer_modal', bool: false });
      this.setClient(customer);
      this.setProjectCustomer(customer);
    });
    Events.$on(_LOAD_MODEL_, newValue => {
      this.model = { ...newValue };
      this.setClient(newValue.customer);
    });
  },
};
</script>

<style lang="scss" scoped>
@import "~_scss/overrides";

.tab-pane {
  border: 1px solid #e1e5eb;
  border-top: 0;
}
.link {
  cursor: pointer;
  color: $primary;
  font-size: 0.7rem;
  margin-left: 10px;
  &:hover {
    text-decoration: underline;
  }
}
</style>
